import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';

export interface CanComponentDeactivate {
    /**
     * `nextUrl` (the URL being navigated to) is optional and only meaningfully populated
     * by `unsavedChangesGuard` itself — components that don't need to distinguish where
     * navigation is headed (the common case) can keep declaring/implementing this with
     * no parameters, same as before this was added.
     */
    canDeactivate: (nextUrl?: string) => Observable<boolean> | Promise<boolean> | boolean;
}

/**
 * Asks a screen with unsaved changes before leaving it. A functional guard (review MR !1 N21, the partner half).
 *
 * `component` is null when this guard is attached to a route that has no component of its own (e.g. a `loadChildren` wrapper route
 * whose actual page component lives on a child route) — nothing to check, so navigation is allowed.
 */
export const unsavedChangesGuard: CanDeactivateFn<CanComponentDeactivate | null> = (component, _currentRoute, _currentState, nextState) =>
    component?.canDeactivate ? component.canDeactivate(nextState?.url) : true;
